"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoSprite = void 0;
const pixi_js_1 = require("pixi.js");
const Animation_1 = require("../Animation/Animation");
const InfoType_1 = require("./InfoType");
class InfoSprite extends pixi_js_1.Sprite {
    constructor(info, textures) {
        super((info.texture && textures && textures[info.texture]) || undefined);
        this.infoSprites = [];
        this.animation = new Animation_1.AnimationManager();
        this.update = (dt) => {
            if (!this.visible)
                return;
            this.animation.update(dt);
            for (const x of this.infoSprites) {
                x.update(dt);
            }
        };
        this.animation.propSetter = Animation_1.CreatePixiPropSetter(this);
        if (info.position)
            InfoType_1.setPositionInfo(this, info.position);
        if (info.animations instanceof Object) {
            for (const prop in info.animations) {
                this.animation.animations.set(prop, info.animations[prop]);
            }
        }
        if (info.children instanceof Array) {
            for (const x of info.children) {
                const c = new InfoSprite(x, textures);
                this.addChild(c);
                this.infoSprites.push(c);
            }
        }
        if (info.blend === "add")
            this.blendMode = pixi_js_1.BLEND_MODES.ADD;
        if (info.tint !== undefined)
            this.tint = parseInt(info.tint.replace("#", "0x"));
    }
    resetAnim() {
        this.visible = true;
        this.animation.currentTime = 0;
        for (const x of this.infoSprites)
            x.resetAnim();
    }
    allAnimEnd() {
        if (!this.animation.ended)
            return false;
        for (const x of this.infoSprites) {
            if (!x.allAnimEnd())
                return false;
        }
        return true;
    }
}
exports.InfoSprite = InfoSprite;
//# sourceMappingURL=InfoSprite.js.map